
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/savvas-request",
      function () {
        return require("private-next-pages/savvas-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/savvas-request"])
      });
    }
  